import React, { useContext } from 'react';
import { Avatar, Skeleton, Tooltip } from 'antd';
import { ProblemBadge, ProblemStatsTopUser } from '../../api/problems';
import { getUserAvatarSrc } from '../../utils/accounts';
import { ThemeContext, ThemeContextState } from '../../context/ThemeContext';
import { AuthContext, AuthContextState } from '../../context/AuthContext';
import styles from './Leaderboard.module.css';

export interface LeaderboardProps {
  users: ProblemStatsTopUser[]
};

// displays leaderboard of top users
const Leaderboard = (props: LeaderboardProps): JSX.Element | null => {
  // get refresh request function from auth context
  const { me } = useContext(AuthContext) as AuthContextState;
  // get current theme from theme context
  const { theme } = useContext(ThemeContext) as ThemeContextState;

  return (
    <div className={styles.mainContainer}>
      <table>
        <thead>
          <tr>
            <th className={styles.tableHeaderCell}>User</th>
            <th className={styles.tableHeaderCell}>Problems Solved</th>
          </tr>
        </thead>
        <tbody>
          {props.users.map((user: ProblemStatsTopUser, userIndex: number) =>
            <tr key={user.display_username} className={(me && me.display_username === user.display_username) ? styles.tableSelfRow : styles.tableRow}>
              <td className={styles.tableUserDataCell}>
                <Avatar src={getUserAvatarSrc(user.display_username)} size={24} />
                <span className={styles.tableUsernameContainer}>
                  {user.username ?
                    user.username : (
                      user.github_username ?
                      user.github_username :
                      user.display_username
                    )
                  }</span>
                &nbsp;&nbsp;
                {user.badges.map((badge: ProblemBadge, badgeIndex: number) => 
                  <Tooltip key={badgeIndex} placement='right' title={badge.title}>
                    <Avatar
                      className={styles.badgeAvatar}
                      src={badge.url.replaceAll('{theme}', theme)}
                      size={badge.size}
                      onClick={badge.redirect ? () => window.open(badge.redirect as string, '_blank', 'noopener,noreferrer') : () => {}}
                    />
                  </Tooltip>
                )}
              </td>
              <td className={styles.tableSolvedProblemsCountDataCell}>{user.solved_problems_count}</td>
            </tr>
          )}
        </tbody>
      </table>
      {props.users.length < 1 && <br />}
      <Skeleton active={true} avatar={{ size: 'small' }} title={false} paragraph={{ rows: 1, width: 128 }} loading={props.users.length < 1} />
      <Skeleton active={true} avatar={{ size: 'small' }} title={false} paragraph={{ rows: 1, width: 128 }} loading={props.users.length < 1} />
      <Skeleton active={true} avatar={{ size: 'small' }} title={false} paragraph={{ rows: 1, width: 128 }} loading={props.users.length < 1} />
    </div>
  );
};

export default Leaderboard;
